import { createContext, useContext } from 'react';
import { DEFAULT_CREATOR_THEME } from './constants/Theme.constants.js';

var CreatorThemeContext = createContext(DEFAULT_CREATOR_THEME);
var useCreatorThemeContext = function () { return useContext(CreatorThemeContext); };

export { CreatorThemeContext, useCreatorThemeContext };
//# sourceMappingURL=CreatorThemeContext.js.map
